import { FilterFieldItem } from "@ukam/core/filters/models/filter-field-item";

export interface FilterFieldItemParams {
  id?: string | null;
  code?: number | null;
  key?: string | null;
  name?: string | null;
  color?: string | null;
  icon?: string | null;
  avatar?: string | null;
  selected?: boolean | null;
}

export function filterFieldItemToParams(item: FilterFieldItem): FilterFieldItemParams {
  return {
    id: item.id ,
    code: item.code ,
    key: item.key ,
    name: item.name ,
    color: item.color ,
    icon: item.icon ,
    avatar: item.avatar ,
    selected: item.selected
  };
}

export function filterFieldItemsToParams(items: FilterFieldItem[] | null | undefined): FilterFieldItemParams[] {
  return items ? items.map(item => filterFieldItemToParams(item)) : [];
}
